import SlideImg from '../../../assets/images/icons/slide-indicator.svg'
import './slide-indicator.scss'

export const SlideIndicator = (props) => {
    const { className } = props

    return <div className={`slide-indicator mt-3 ${className}`}>
        <span><img src={SlideImg} alt="" width={40}/></span>
    </div>
}